import { addYears, startOfMonth } from "date-fns";
import { FUTURE_CONTRACT_START_MAX_YEARS } from "web_myplann/Goals/constants";

export const getMaxFutureContractStartDate = (now: Date = new Date()): Date =>
	startOfMonth(addYears(now, FUTURE_CONTRACT_START_MAX_YEARS));
